import { useContext } from "react";
import { PatientIntakesModalContext } from "./PatientIntakesModalProvider";

export const usePatientIntakesModal = () => {
  return useContext(PatientIntakesModalContext);
};
